module.exports = __webpack_public_path__ + "resources/globe/bump.jpg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=resources/globe/bump.jpg!./src/resources/globe/bump.jpg
// module id = 2503
// module chunks = 0